import Icon from '../atomic/Icon'
import LazyLoad from 'react-lazyload'
import Link from 'next/link'
import React from 'react'
import { sendGTMData } from '../../utils/gtm'

const AutoreCard = React.memo(({ autore, classes = '' }) => {
  const thumb = autore.main_image ? autore.main_image : autore.avatar ? autore.avatar : null
  const nome_cognome = autore.titolo ? autore.titolo : autore.nome + ' ' + autore.cognome

  const handleGTM = () => {
    sendGTMData({
      event: 'GAevent',
      eventID: '15',
      eventCategory: 'interazione_contenuti',
      eventAction: 'click',
      eventLabel: 'autori',
      moreInfo: nome_cognome.toGTMFormat(),
    })
  }

  return (
    <Link legacyBehavior href={autore.url}>
      <a className={`autore-card ${classes}`} onClick={() => handleGTM()}>
        <div className="autore-card__front">
          <div className="autore-card__header">
            {thumb ? (
              <div className="autore-card__image-wrapper">
                <LazyLoad height={65} offset={100} once>
                  <img
                    src={thumb}
                    alt={nome_cognome?.toAltTitle()}
                    title={nome_cognome?.toAltTitle()}
                    className="autore-card__image"
                  />
                </LazyLoad>
              </div>
            ) : (
              <Icon classes="autore-card__default-image" id="user" />
            )}
            {autore.redazionale ? (
              <Icon id="logosymbol" classes="icon--logosymbol" />
            ) : (
              <Icon id="community" classes="icon--community" />
            )}
          </div>
          <div className="autore-card__content">
            <p className="autore-card__fullname">
              {autore.nome?.capitalize()} {autore.cognome?.capitalize()}
            </p>
            <p className="autore-card__type">{autore.headline}</p>
          </div>
        </div>
      </a>
    </Link>
  )
})

export default AutoreCard
